export function buildWebApplicationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "ResumePro",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "author": {
      "@type": "Person",
      "name": "Farhad Rezaei"
    },
    "featureList": [
      "AI resume customization",
      "Cover letter generation",
      "Job description matching",
      "PDF export"
    ]
  };
}
